export const TITLE_MAP = {
  vehicles: 'Vehicles',
  summary: 'Summary',
  ecus: 'ECUs',
  pneumatics: 'Pneumatics',
  pto: 'PTO',
  ctpreport: 'CTP Report',
  switchandgauge: 'Switch & Gauge',
  history: 'History',
  fleet: 'Manage Fleet',
  'line-note-reader': 'Line Note Reader',
  'dash-layout': 'CHEC Dash',
  'odx-data-translator': 'Data Translator',
  ctp: 'CTP Mapping',
  features: 'Features',
  'reference-parameters': 'RPs',
  'support-parameters': 'SPs',
  'feature-collections': 'Feature Collections',
  'pto-templates': 'PTO Templates',
  'release-notes': 'Release Notes',
  requirements: 'System Requirements',
  'fast-features': 'Fast Features',
  'fast-feature-errors': 'Fast Feature Error Reporting',
  ctpReport: 'CTP Report',
}
